import React, { Fragment } from "react";
import { Image } from "react-bootstrap";

import classes from "./NetworkAlert.module.css";
import errorImage from "../../../assets/images/icon-error.svg";
import { withTranslation } from "react-i18next";

interface Props {
  modalClosed: () => void;
  networkErrorText?: boolean;
  error: string;
  t:any;
}

const NetworkAlert: React.FunctionComponent<Props> = (props) => {
  const { modalClosed, error,networkErrorText = true } = { ...props };
  return (
    <Fragment>
      <div className="popupHeader popupHeaderBdr">
        {/* <h6>Unknown Error</h6> */}
        <div className="closeBtn closeBtnBlue" onClick={modalClosed}>
          X
        </div>
      </div>

      <div className={classes.popupBody}>
        <Image
          src={errorImage}
          alt={errorImage}
          className={classes.errorImage}
        />
        <div className={classes.networkAlert}>
          <h4>{error ? error : props.t('error.networkErrorText')}</h4>
         {networkErrorText? <strong>
            {props.t('error.networkErrorText')}
            <br />
            {props.t('error.networkErrorText1')}
          </strong>:undefined}
        </div>
      </div>
    </Fragment>
  );
};
export default withTranslation()(NetworkAlert);
